import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    check: {
      marginTop: '4px',
      color: 'green'
    },
    wrong: {
      marginTop: '4px',
      color: 'red'
    }
  })
);
